import {RouterModule, Routes} from '@angular/router';
import {AuthenticationGuard} from '@bndes/bndes-ux4/bn-seguranca';
import {EscolhaModalidadeGuard} from '../../interceptors/escolha-modalidade.guard';
import {NgModule} from '@angular/core';
import {ModalidadeScrPesquisa} from './pequisa/modalidade-scr-pesquisa';
import {ModalidadeScrCadastroComponent} from './cadastro/modalidade-scr-cadastro.component';
import {HabilitacaoScrComponent} from './habilitacao-scr/habilitacao-scr.component';

const routes: Routes = [
  {
    path: 'modalidade-scr',
    component: ModalidadeScrPesquisa,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard]
  },
  {
    path: 'modalidade-scr/cadastro',
    component: ModalidadeScrCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard]
  },
  {
    path: 'modalidade-scr/habilitacao',
    component: HabilitacaoScrComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ModalidadeScrRoutingModule {
}
